<template>
  <table class="table table-hover table-bordered bg-white table-striped">
      <thead>
          <th>#</th>
          <th>Номер ДБЗ</th>
          <th>Ошибка</th>
          <!-- <th>{{ $t('app.action') }}</th> -->
      </thead>
      <tbody>
        <template v-if="!load">
          <tr v-for="(excel, index) in excel.import_deleted_debts">
              <td>{{index+1}}</td>
              <td>
                <i class="fa fa-check text-success fa-lg" aria-hidden="true" v-if="excel.status == 'done'"></i>
                <i class="fa fa-times text-danger fa-lg" aria-hidden="true" v-if="excel.status == 'failed'"></i>
                {{excel.debt_number}}
              </td>
              <td>{{excel.errors}}</td>
              <!-- <td>
                <a :href="`/admin/debtors?iin=${excel.debtor_iin}`" target="_blank">
                  <i class="fa fa-share-square-o" aria-hidden="true"></i>
                </a>
              </td> -->
          </tr>
        </template>
        <tr v-if="load">
          <td colspan="11" class="text-center">
            <loader-wave/>
          </td>
        </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    excel: Object,
    load: Boolean,
  },
}
</script>
